import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureApiRestService from './services/apiService';
import configureStore from "./store/index";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
configureApiRestService();
const store = configureStore();
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
